// eslint-disable-next-line
export default {
  API_PROTOCOL: process.env.REACT_APP_API_PROTOCOL || 'https',
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || '',
  USER_POOL_APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || '',
  USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
}
